import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { pathHomePage } from "../../../../config/constants";
import { isProtocolWithDetails } from "../../../../config/functions";
// Components
import {
  SessionMainDiv,
  SessionDiv,
  InfoDiv,
  SessionText,
  ShowExtraInfoButton,
  ShowExtraInfoImg,
  ExtraInfoDiv,
  ExtraInfoSessionDiv,
  ExtraInfoSessionTitle,
  DetailsDiv,
  DetailsLink,
  DetailsImg,
  DeleteSessionButton,
  DeleteSessionImg,
} from "./styles";
import Popup from "../../../popup";
import DeleteSession from "../deleteSession";
// Assets
import IcoArrowUp from "../../../../assets/ico_arrow_up.svg";
import IcoArrowDown from "../../../../assets/ico_arrow_down.svg";
import IcoDeleteSession from "../../../../assets/ico_trash_gray.svg";
import IcoDetails from "../../../../assets/ico_details.svg";

const SessionData = ({
  sessionId,
  sessionNumber,
  date,
  hour,
  score,
  software,
  toggleRechargeReports,
  setToggleRechargeReports,
  setIsLoadingReports,
}) => {
  const [isShowingDeleteSession, setIsShowingDeleteSession] = useState(false);
  const [showExtraInfo, setShowExtraInfo] = useState(false);
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const { patientId, protocolId } = useParams();
  const [t] = useTranslation("global");

  const handleShowExtraInfo = () => setShowExtraInfo(!showExtraInfo);

  const handleShowDeleteSession = () => setIsShowingDeleteSession(true);

  return (
    <SessionMainDiv>
      <SessionDiv isProtocolWithDetails={isProtocolWithDetails(protocolId)}>
        <InfoDiv>
          <SessionText width="100px" width910="75px">
            {sessionNumber}
          </SessionText>
          <SessionText width="138px" width910="80px">
            {date}
          </SessionText>
          <SessionText width="108px" width910="80px">
            {hour}
          </SessionText>
          <ShowExtraInfoButton onClick={handleShowExtraInfo}>
            <ShowExtraInfoImg src={showExtraInfo ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
          </ShowExtraInfoButton>
        </InfoDiv>
        <ExtraInfoDiv show={showExtraInfo}>
          {!isProtocolWithDetails(protocolId) && (
            <ExtraInfoSessionDiv>
              <ExtraInfoSessionTitle>{t("reports.sessionsList.tableScoreText")}</ExtraInfoSessionTitle>
              <SessionText width="120px" width910="auto">
                {score}
              </SessionText>
            </ExtraInfoSessionDiv>
          )}
          {isProtocolWithDetails(protocolId) && (
            <ExtraInfoSessionDiv>
              <DetailsDiv width="90px">
                <ExtraInfoSessionTitle>{t("reports.sessionsList.tableDetail")}</ExtraInfoSessionTitle>
                <DetailsLink to={`${pathHomePage}/session-details/${clinicianToken}/${software}/${patientId}/${protocolId}/${sessionId}`}>
                  <DetailsImg src={IcoDetails} alt="ico-details" />
                </DetailsLink>
              </DetailsDiv>
            </ExtraInfoSessionDiv>
          )}
          <DeleteSessionButton onClick={handleShowDeleteSession}>
            <DeleteSessionImg src={IcoDeleteSession} alt="ico-delete" />
          </DeleteSessionButton>
          <Popup isShowed={isShowingDeleteSession} setIsShowed={setIsShowingDeleteSession}>
            <DeleteSession
              setIsShowingDeleteSession={setIsShowingDeleteSession}
              software={software}
              sessionId={sessionId}
              toggleRechargeReports={toggleRechargeReports}
              setToggleRechargeReports={setToggleRechargeReports}
              setIsLoadingReports={setIsLoadingReports}
            />
          </Popup>
        </ExtraInfoDiv>
      </SessionDiv>
    </SessionMainDiv>
  );
};

export default SessionData;
